import React, { lazy } from 'react';
import {SettingsRoutePath,fullPath} from "@settings/constants";

const ServiceSubscription =  /* #__LOADABLE__ */() => import("@settings/ServiceSubscription");
const PayersAndMeasures =  /* #__LOADABLE__ */() => import("@settings/PayersAndMeasures");
const ClinicManagement =  /* #__LOADABLE__ */() => import("@settings/ClinicManagement");
const UserManagement =  /* #__LOADABLE__ */() => import("@settings/UserManagement");
const CustomizeApp =  /* #__LOADABLE__ */() => import("@settings/CustomizeApp");
const UserRoleManagement =  /* #__LOADABLE__ */() => import("@settings/UserRoleManagement");
const HelpCenter =  /* #__LOADABLE__ */() => import("@components/HelpCenter");
const DataImport =  /* #__LOADABLE__ */() => import("@settings/DataImport");
const SmartScheduler =  /* #__LOADABLE__ */() => import("@settings/SmartScheduler");
const LRConfig =  /* #__LOADABLE__ */() => import("@settings/LRConfig");
const TagManager =  /* #__LOADABLE__ */() => import("@components/TagManager");

const SettingsRouteConfig = {
  DEFAULT: {
    name: "default",
    exact: true,
    loadablComp: ServiceSubscription,
  },
  SERVICE_SUBSCRIPTION: {
    name: "service_subscription",
    loadablComp: ServiceSubscription,
  },
  PAYERS_MEASURES: {
    name: "payers_measures",
    loadablComp: PayersAndMeasures,
  },

  CLINIC_MANAGEMENT: {
    name: "clinic_management",
    loadablComp: ClinicManagement,
  },
  HELP: {
    name: "help_center",
    loadablComp: HelpCenter
  },
  USER_MANAGEMENT: {
    name: "user_management",
    loadablComp: UserManagement
  },
  CUSTOMIZE_APP: {
    name: "customize_app",
    loadablComp: CustomizeApp
  },
  USER_ROLE_MANAGEMENT: {
    name: "user_role_management",
    loadablComp: UserRoleManagement
  },
  DATA_IMPORT: {
    name: "data_import",
    loadablComp: DataImport
  },
  SMART_SCHEDULER: {
    name: "smart_scheduler",
    loadablComp: SmartScheduler
  },
  LR_INTEGRATION: {
    name: "lr-integration",
    loadablComp: LRConfig
  },
  TAG_MANAGER: {
    name: "tag_manager",
    loadablComp: TagManager
  }
};
Object.keys(SettingsRouteConfig).forEach(rkey=>{
  if(SettingsRoutePath[rkey]){
    SettingsRouteConfig[rkey] = {...SettingsRouteConfig[rkey],...SettingsRoutePath[rkey],fullPath:fullPath(SettingsRoutePath[rkey].path)};
  }
  else{
    console.log('GlobalRoute Path info missing for',rkey)
  }
})
//Object.values(SettingsRouteConfig).forEach(r=>r.fullPath = fullPath(r.path));
export const SettingsRoutes = SettingsRouteConfig;
export const activeSettingsRoutes = (activeRoutes)=>{
  return Object.keys(SettingsRouteConfig).filter(rKey=>activeRoutes.includes(rKey)).reduce((rm,rKey)=>{
    rm[rKey] = {...SettingsRouteConfig[rKey],componentOpts:{activeRoutes}};
    return rm;
  },{})
}

